import Selectorg from './Selectorg'
import CategoryCas from './CategorySelect'
import CategoryMultCas from './CategoryMultSelect'
import CustomTransfer from './CustomTransfer'
import CityCascader from './CityCascader'
import FormTable from './FormTable'
import FormTableItem from './FormTable/form-table-item.vue'
import TagCas from './TagSelect'
import areaCas from './AreaSelect'
export default {
    install(Vue)  {
        Vue.component(Selectorg.name, Selectorg)
        Vue.component(CategoryCas.name, CategoryCas)
        Vue.component(CustomTransfer.name, CustomTransfer)
        Vue.component(CityCascader.name, CityCascader)
        Vue.component(FormTable.name, FormTable)
        Vue.component(FormTableItem.name, FormTableItem)
        Vue.component(TagCas.name, TagCas)
        Vue.component(areaCas.name, areaCas)
        Vue.component(CategoryMultCas.name, CategoryMultCas)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js